import { application } from "../application"

import FlyoutController from "./flyout_controller";
application.register("flyout", FlyoutController);
import AosController from "./aos_controller";
application.register("aos", AosController);
import DarkModeController from "./dark_mode_controller";
application.register("dark-mode", DarkModeController);
import ApplicantsController from "./applicants_controller";
application.register("applicants", ApplicantsController);
import AutoScrollController from "./auto_scroll_controller";
application.register("auto-scroll", AutoScrollController);
import RangeController from "./range_controller";
application.register("range", RangeController);
import KanbanController from "./kanban_controller";
application.register("kanban", KanbanController);
import PricingController from "./pricing_controller";
application.register("pricing", PricingController);
import CurrentTimeController from "./current_time_controller";
application.register("current-time", CurrentTimeController);
import OffcanvasController from "./offcanvas_controller";
application.register("offcanvas", OffcanvasController);
import CommandPaletteController from "./command_palette_controller";
application.register("command-palette", CommandPaletteController);

import { RailsuiClipboard, RailsuiCountUp, RailsuiCombobox, RailsuiDateRangePicker, RailsuiDropdown, RailsuiModal, RailsuiRange, RailsuiReadMore,RailsuiSelectAll, RailsuiTabs, RailsuiToast, RailsuiToggle, RailsuiTooltip } from 'railsui-stimulus'

application.register('railsui-clipboard', RailsuiClipboard)
application.register('railsui-count-up', RailsuiCountUp)
application.register('railsui-combobox', RailsuiCombobox)
application.register('railsui-date-range-picker', RailsuiDateRangePicker)
application.register('railsui-dropdown', RailsuiDropdown)
application.register('railsui-modal', RailsuiModal)
application.register('railsui-range', RailsuiRange)
application.register('railsui-read-more', RailsuiReadMore)
application.register('railsui-select-all', RailsuiSelectAll)
application.register('railsui-tabs', RailsuiTabs)
application.register('railsui-toast', RailsuiToast)
application.register('railsui-toggle', RailsuiToggle)
application.register('railsui-tooltip', RailsuiTooltip)
